<template>
    <div>
        <global-header />
        <login-register v-if="showLoginRegister"/>
        <div class="routerView-wrapper">
            <!-- <keep-alive> -->
                <router-view/>
            <!-- </keep-alive> -->
        </div>
        <playerUI/>
        <div v-if="showNetworkError" class="networkError-mask">
            <img class="main" src="@/assets/networkError/main.png">
            <img class="sorry" src="@/assets/networkError/sorry.png">
            <p>本站点启用了防盗链功能，请返回首页继续阅读</p>
            <button @click="goTotalIndex">返回首页</button>
        </div>
    </div>
</template>

<script>
    import GlobalHeader from '@/components/globalHeader'
    import LoginRegister from '@/components/loginRegister'
    import playerUI from '@/components/player'
    import backBtn from '@/components/backBtn'
    export default {
        components: {
            GlobalHeader,
            playerUI,
            LoginRegister,
            backBtn
        },
        data () {
            return {
                showNetworkError: false
            }
        },
        computed: {
            routeName () {
                const { name } = this.$route
                return name
            },
            showLoginRegister () {
                return this.$store.state.showLoginRegister
            }
        },
        watch: {
            articleId () {
                const { resourceId } = this.$route.params
                if (resourceId === this.lastedResId) {
                    this.$tools.getWXConfigHideMenu.call(this)
                    this.getContent()
                }
            }
        },
        created () {
            let userInfos
            try {
                userInfos = this.$cookies.get('user')
            } catch (error) {
                console.log(error)
            }
            if (userInfos) {
                userInfos = JSON.parse(userInfos)
            }
            this.$store.commit('setUserInfos', userInfos)
            this.getPageConfig()
        },
        mounted () {
        },
        methods: {
            async getPageConfig () {
                try {
                    const { Data } = await this.$apis('pageConfig').getPageConfig()
                    const {
                        siteColor, logoURL, resourceType, appDownloadUrl,functionList,ExtensionURL,NavBackgroundImage,ExtensionTopURL,
                            navsColor,
                            navSelectedColor,
                            isShowResouceCount,
                            enableCastLogin
                    } = Data
                    let { ServiceName } = Data
                    //手动加入测试

                    let loginurldata = await this.$apis('user').getloginurl();
                    this.$store.commit('setUserLoginUrl',loginurldata.Data);
                    //resourceType.push('video');
                    ServiceName = ServiceName || '精品阅览室'
                    //this.$store.commit('setIsNexus', isNexus === 'true')
                    let userip = await this.$apis('user').getuserip();
                    this.$store.commit('setIsNexus',functionList)
                    this.$store.commit('setThemeColor', siteColor)
                    this.$store.commit('setServiceName', ServiceName)
                    this.$store.commit('setLogoURL', logoURL)
                    this.$store.commit('setNavBackgroundImage', NavBackgroundImage);
                    this.$store.commit('setExtensionURL', ExtensionURL);
                    this.$store.commit('setExtensionTopURL',ExtensionTopURL);
                    this.$store.commit('setGlobalNavsData', resourceType)
                    this.$store.commit('setAppDownloadUrl', appDownloadUrl)
                    this.$store.commit('setUserIp',userip.Data);
                    this.$store.commit('setNavsColor',navsColor);
                    if(!navsColor){
                        this.$store.commit('setNavsColor','#ffffff');
                    }
                    this.$store.commit('setNavSelectedColor',navSelectedColor);
                    if(!navSelectedColor){
                        this.$store.commit('setNavSelectedColor','#000000');
                    }
                    if(isShowResouceCount){
                        this.$store.commit('setIsShowResouceCount',JSON.parse(isShowResouceCount));
                    }
                    if(enableCastLogin){
                        this.$store.commit('setEnableCastLogin',JSON.parse(enableCastLogin));
                    }
                    this.filterBannerData(Data)
                    this.siteHTMLHeader(ServiceName)
                    this.siteFavicon(logoURL)


                    let _resoucelist = await this.$apis('user').getallresourecelist();
                    this.$store.commit('setAllResouceList',_resoucelist.Data);


                    
                    //debugger;
                } catch (error) {
                    const { Code } = error
                    if (Code === 0) {
                        this.showNetworkError = true
                    }
                    console.log(error)
                }
            },
            siteHTMLHeader (str) {
                const title = document.getElementsByTagName('title')[0]
                title.innerText = str
            },
            siteFavicon (href) {
                if (!href) {
                    return
                }
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
                link.type = 'image/x-icon'
                link.rel = 'shortcut icon'
                link.href = href
                document.getElementsByTagName('head')[0].appendChild(link)
            },
            async filterBannerData (obj) {
                const arr = []
                const numArr = [1, 2, 3, 4];
                const typeArr = ['magazine','book','audio','video','newspaper'];
                for (let i = 0; i < typeArr.length; i++) 
                {         
                    const _singlearr = [];        
                    for (var j = 1; j <= 4; j++) {
                        const srcKey = `${typeArr[i]}banner${ j }`
                        const linkKey = `${typeArr[i]}bannerLinkSrc${ j }`
                        if (obj[srcKey]) {
                            let _objsrcKey = obj[srcKey].split(',');
                            let _objlinkKey = obj[linkKey].split(',');
                            _singlearr.push({
                                imgSrc: _objsrcKey[0],
                                value: _objlinkKey[0]
                            });
                            /*
                            if(_objsrcKey.length>1)
                            {
                                arr.push({
                                    imgSrc: _objsrcKey[1],
                                    value: _objlinkKey[1]
                                })                            
                            }*/
                        }
                    }
                    arr.push(_singlearr)  
                }
                /*
                numArr.forEach((e) => {
                    const srcKey = `banner${ e }`
                    const linkKey = `bannerLinkSrc${ e }`
                    if (obj[srcKey]) {
                        let _objsrcKey = obj[srcKey].split(',');
                        let _objlinkKey = obj[linkKey].split(',');
                        arr.push({
                            imgSrc: _objsrcKey[0],
                            value: _objlinkKey[0]
                        });
                        if(_objsrcKey.length>1)
                        {
                            arr.push({
                                imgSrc: _objsrcKey[1],
                                value: _objlinkKey[1]
                            })                            
                        }

                    }
                })*/

                let advcode  = [
                    {t:'3e6fe164-54d9-4453-92e2-39fb05d53693',c:'00'},
                    {t:'3e6fe164-54d9-4453-92e2-39fb05d53693',c:'01'},
                    {t:'3e6fe164-54d9-4453-92e2-39fb05d53693',c:'02'},
                    {t:'3e6fe164-54d9-4453-92e2-39fb05d53693',c:'03'},
                    {t:'3e6fe164-54d9-4453-92e2-39fb05d53693',c:'04'},
                ];
                for (let i = 0; i < arr.length; i++) 
                {
                    if(arr[i].length<=0)
                    {
                        let _data = await this.$apis('advertisement').getAdvertisement(advcode[i].t,advcode[i].c);
                        for (let j = 0; j < _data.Data.length; j++) {
                            arr[i].push({
                                imgSrc:_data.Data[j].Images[0],
                                value:_data.Data[j].Source
                            })
                        }
                    }
                }
                this.$store.commit('setBannerData', arr)
            },
            goTotalIndex () {
                // const a = 'https://dspc.dps.qikan.com/Template/WebLibrary/index.html#/magazine'
                const baseUrl = window.location.href.split('Template/WebLibrary')[0]
                // const fakseUrl = a.split('Template/WebLibrary')[0]
                // window.location.href = `${ fakseUrl }pc2`
                window.location.href = `${ baseUrl }pc2`
            }
        }
    }
</script>

<style lang="scss" scoped>
    .routerView-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        top: 160px;
        right: 0;
        bottom: 0;
        left: 0;
        background: #f6f6f6;
        min-height: 460px;
    }

    .networkError-mask {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            display: block;
        }

        .main {
            width: 500px;
            margin-top: -140px;
        }

        .sorry {
            width: 133px;
            margin: 30px 0 20px;
        }

        p {
            margin-bottom: 30px;
            
            font-size: 18px;
            color: #999999;
            text-align: center;
        }

        button {
            width: 180px;
            height: 54px;
            background: #0084FF;
            border-radius: 8px;
            
            font-size: 20px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
        }
    }
</style>

<style lang="scss">
    body {
        background: #f6f6f6;
    }
    .site-footer {
        width: 100%;
        height: 128px;
        /*background-image: url("../../assets/footer.png");
        background-repeat: no-repeat;
        background-position: center 30px;*/
        border-top: 1px solid #F0F2F7;
    }
    h5 {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
